// Generated by Argon compiler — do not edit by hand.
// CSR store output: reactive shared state with no runtime dependency.

const __argonSubs = new Map();

function __argonNotify(key) {
  for (const fn of __argonSubs.get(key) ?? []) fn();
}

export function argonSubscribe(key, fn) {
  let set = __argonSubs.get(key);
  if (!set) __argonSubs.set(key, set = new Set());
  set.add(fn);
  return () => {
    set.delete(fn);
    if (set.size === 0) __argonSubs.delete(key);
  };
}

export const sidePanel = {};
let __argon_sidePanel_open = false;
Object.defineProperty(sidePanel, "open", {
  enumerable: true,
  get() { return __argon_sidePanel_open; },
  set(value) {
    if (Object.is(__argon_sidePanel_open, value)) return;
    __argon_sidePanel_open = value;
    __argonNotify("sidePanel.open");
  },
});

let __argon_sidePanel_tab = "files";
Object.defineProperty(sidePanel, "tab", {
  enumerable: true,
  get() { return __argon_sidePanel_tab; },
  set(value) {
    if (Object.is(__argon_sidePanel_tab, value)) return;
    __argon_sidePanel_tab = value;
    __argonNotify("sidePanel.tab");
  },
});

let __argon_sidePanel_selectedSubagent = "";
Object.defineProperty(sidePanel, "selectedSubagent", {
  enumerable: true,
  get() { return __argon_sidePanel_selectedSubagent; },
  set(value) {
    if (Object.is(__argon_sidePanel_selectedSubagent, value)) return;
    __argon_sidePanel_selectedSubagent = value;
    __argonNotify("sidePanel.selectedSubagent");
  },
});

export function argonSnapshot() {
  return {
    sidePanel: { open: sidePanel.open, tab: sidePanel.tab, selectedSubagent: sidePanel.selectedSubagent },
  };
}

export function argonHydrate(snapshot) {
  if (!snapshot) return;
  if (snapshot.sidePanel) {
    if ("open" in snapshot.sidePanel) sidePanel.open = snapshot.sidePanel.open;
    if ("tab" in snapshot.sidePanel) sidePanel.tab = snapshot.sidePanel.tab;
    if ("selectedSubagent" in snapshot.sidePanel) sidePanel.selectedSubagent = snapshot.sidePanel.selectedSubagent;
  }
}

const __argonPayload = globalThis.document?.querySelector?.('script[type="application/json"][data-argon-stores]');
if (__argonPayload?.textContent) argonHydrate(JSON.parse(__argonPayload.textContent));
